window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    body: 'body',
    cartSection: '#shopify-section-template-cart',
    cartSidebar: '#cart-sidebar',
    cartSidebarInner: '#cart-sidebar .cart-sidebar',
    siteHeader: '.site-header__nav-bar',
    cartCount: '[data-cart-count]',
    cartRemove: '[data-cart-remove]',
    cartStatus: '[data-cart-status]',
    qtyInput: '[data-quantity-input]',
    qtyChanger: '.cart .quantity-selector__changer',
    sliderQtyChanger: '.product-card__add-qty .quantity-selector__changer',
    thumbnails: '[data-cart-item-image]',
    cartUpsells: '#cart-upsells'
  };

  var classes = {
    cartNoCookies: 'cart--no-cookies',
    inputError: 'input--error'
  };

  var mediumUpQuery = '(min-width: ' + theme.breakpoints.mediumUp + 'px)';

  function Cart(container) {
    this.$container = $(container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(classes.cartNoCookies);
    }

    this.$thumbnails.css('cursor', 'pointer');

    this.$container.on('click', selectors.thumbnails, this._handleThumbnailClick);
    this.$container.on('click',selectors.cartRemove, this._removeItem.bind(this));
    var thisSection = this;
    thisSection._initEvents();

    $('body').on('cartrefresh',function(){
      thisSection._refreshCart();
    });

    if ($(selectors.cartSidebar).length) {
      this.stickySidebar(mediumUpQuery);
    }
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {
    _removeItem: function(evt){
      evt.preventDefault();
      var self = this;
      var $thisLink = $(evt.target);
      var itemID = $thisLink.attr('data-key');
      var changeObj = {id: itemID, quantity: 0};
      var params = {
        url: '/cart/change.js',
        data: changeObj,
        dataType: 'json'
      };

      if($thisLink.hasClass('cart__remove--free-gift')){
        sessionStorage.setItem('hs-decline-free-gift','true');
      }

      function callback(){
        self._removeItemCallback();
      }

      $.post(params).done(function(item){
        hsCheckFreeGifts(callback,null);
      }).fail(function(data){
        console.error(data);
      });
    },

    _removeItemCallback: function(){
      this._refreshCart();
      this._updateLiveRegion();
    },

    _initEvents: function(){
      var self = this;
      self.$container.on('click.qtyBtn',selectors.qtyChanger + ', ' + selectors.sliderQtyChanger,function(){
        hsQtySelectors($(this));
      });

      $('.cart__submit').on('click.checkout',function(e){
        // window._klOnsite = window._klOnsite || [];
        // window._klOnsite.push(['openForm', 'Vnag9S']);
        // Check quantities prior to going into checkout
        e.preventDefault();
        var linkURL = $(this).attr('href');
        var bundles = [];
        var nonbundles = [];
        $.getJSON('/cart.js',function(cart){
          for(var i = 0, all = cart.items.length; i < all; i++){
            var item = cart.items[i];
            var line = i + 1;
            var bundleProperty = null;
            if(item.properties !== null){
              bundleProperty = item.properties['_bundleData'] || null;
            }
            if(bundleProperty !== null){ // collect all bundles in cart
              var bundleItemObj = {
                bundleData: JSON.parse(bundleProperty),
                line: line
              };
              bundles.push(bundleItemObj);
            } else if(!item.gift_card) { // collect all non-bundle, non-gift card products in cart
              var itemObj = {
                "handle": item.handle,
                "id": item.id,
                "qty": item.quantity,
                "line": line
              };
              nonbundles.push(itemObj);
            }
          }
          theme.Inventory.validateCartQuantities(bundles,nonbundles,linkURL,null);
        });
      });
    },

    _unload: function(){
      $('body').off('cartrefresh');
      $('.cart__submit').off('click.checkout');
      this.$container.off('click.qtyBtn');
    },

    _refreshCart: function(){
      var self = this;
      self._unload();
      $.get('/cart',function(data){
        var cartHtml = $(data).find(selectors.cartSection).html();
        $(selectors.cartSection).html(cartHtml);
        var sections = new theme.Sections();
        sections.register('template-cart', theme.Cart);
        $('#updating-mask').remove();
        $.getJSON('/cart.js',function(cart){
          $(selectors.cartCount).text(cart.item_count);
        });
      });
    },

    _updateLiveRegion: function(item) {
      var $liveRegion = $(selectors.cartStatus);
      $liveRegion.html(theme.strings.cartUpdated).attr('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        $liveRegion.attr('aria-hidden', true);
      }, 1000);
    },

    _handleThumbnailClick: function(evt) {
      var url = $(evt.target).closest(selectors.cartItem).data('cart-item-url');
      window.location.href = url;
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    },

    stickySidebar: function(mediumUpQuery){
      var init_scrollTop = $(window).scrollTop(),
          init_sideWidth = $(selectors.cartSidebar).width(),
          init_headerHeight = $(selectors.siteheader).outerHeight(),
          fixedOffset = 30,
          offsetTop = init_headerHeight + fixedOffset,
          init_sideOffsetTop = $(selectors.cartSidebar).offset().top - offsetTop;

      enquire.register(mediumUpQuery, {
        match: function() {
          if (init_scrollTop > init_sideOffsetTop) {
            $(selectors.cartSidebarInner).addClass('fixed').css('width', init_sideWidth);
          }
        }
      });

      function stickyCartSidebar(){
        enquire.register(mediumUpQuery, {
          match: function() {
            if($(selectors.cartSidebar).length){
              var scrollTop = $(window).scrollTop(),
                  new_headerHeight = $(selectors.siteHeader).outerHeight(),
                  new_sideWidth = $(selectors.cartSidebar).width(),
                  new_offsetTop = new_headerHeight + fixedOffset,
                  new_sideOffsetTop = $(selectors.cartSidebar).offset().top - new_offsetTop,
                  new_sideHeight = $(selectors.cartSidebar).outerHeight(),
                  new_blockHeight = $(selectors.cartSidebarInner).outerHeight(),
                  bottomOffset = (new_sideOffsetTop + new_sideHeight) - new_blockHeight;

              if (scrollTop > new_sideOffsetTop) {
                $(selectors.cartSidebarInner).addClass('fixed').css('top',new_offsetTop).css('width', new_sideWidth);
              } else {
                $(selectors.cartSidebarInner).removeClass('fixed').removeAttr('style');
              }
              if (scrollTop > bottomOffset){
                $(selectors.cartSidebarInner).addClass('bottom');
              } else {
                $(selectors.cartSidebarInner).removeClass('bottom');
              }
            }
          },
          unmatch: function() {
            $(selectors.cartSidebarInner).removeClass('fixed bottom').removeAttr('style');
          }
        });
      }

      $(window).on('scroll.cartSidebar resize.cartSidebar', function() {
        stickyCartSidebar();
      }).trigger('scroll.cartSidebar');
    }
  });

return Cart;
})();

$(document).ready(function() {
  window.theme = window.theme || {};
  var sections = new theme.Sections();
  sections.register('template-cart', theme.Cart);
});